import { newsList } from '@/mocks/home';

export default function NewsSection() {
  return (
    <section id="news" className="bg-background-50">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-newspaper-line" />
              Updates
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">资讯速览</h2>
            <p className="mt-2 text-sm text-foreground-600">
              版本更新、安装教程与使用技巧，用最短的篇幅讲清楚一个具体问题。
            </p>
          </div>
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-xs font-medium text-foreground-800 transition-colors hover:bg-background-100 md:self-auto"
          >
            查看更多问答
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-5">
          {newsList.map((item, idx) => (
            <article
              key={item.title}
              className={`flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                  {item.tag}
                </span>
                <time className="text-[11px] text-foreground-500">{item.date}</time>
              </div>
              <h3
                className={`mt-3 font-heading font-bold text-foreground-950 ${
                  idx === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}
              >
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                阅读详情
                <i className="ri-arrow-right-s-line" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}